import { useQuery, skipToken } from "@tanstack/react-query";
import { getMerchantsPublicIDEmployeesEmployeePublicID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

export const merchantEmployeeKeys = {
  all: ["MERCHANT_EMPLOYEE"] as const,
  singleMerchant: (merchantPublicID?: string) =>
    [...merchantEmployeeKeys.all, merchantPublicID] as const,
  singleEmployee: (merchantPublicID?: string, employeePublicID?: string) =>
    [
      ...merchantEmployeeKeys.singleMerchant(merchantPublicID),
      employeePublicID,
    ] as const,
};

export const useMerchantEmployee = (
  merchantPublicID?: string,
  employeePublicID?: string,
) =>
  useQuery({
    queryKey: merchantEmployeeKeys.singleEmployee(
      merchantPublicID,
      employeePublicID,
    ),
    queryFn:
      merchantPublicID && employeePublicID
        ? processResponseWithApiProblemDetails(() =>
            getMerchantsPublicIDEmployeesEmployeePublicID(
              merchantPublicID,
              employeePublicID,
            ),
          )
        : skipToken,
  });
